import { replaceFragments } from '../utils/fragments.js'

export default function (state = {
	async: true,
}) {
	return {
		status: null,

		init() {
			this.attachEvents()
		},

		attachEvents() {
			this.$refs.addToCartTrigger.addEventListener('click', (e) => {
				this.addToCart(e)
			})
		},

		addToCart(e) {
			e.preventDefault()

			const form = this.$root

			if (!state.async) {
				form.submit()
				return
			}

			const formData = new FormData()
			let invalid = false

			const inputs = form.querySelectorAll('input, select, textarea')
			inputs.forEach((input) => {
				if (!input.name || !input.value) {
					return
				}

				if (input.name === 'add-to-cart') {
					return
				}

				if (input.name === 'variation_id' && input.value > 0) {
					formData.set('product_id', input.value)
					return
				}

				if (
					input.type === 'checkbox'
					&& input.required
					&& !input.checked
				) {
					invalid = true
					input.reportValidity()

					return
				}

				if (input.type === 'checkbox' && !input.checked) {
					return
				}

				formData.set(input.name, input.value)
			})

			if (invalid) {
				return
			}

			for (const key in this.$refs.addToCartTrigger.dataset) {
				const keyName = key.replace(/([A-Z])/g, g => `-${g[0].toLowerCase()}`)

				if (formData.has(keyName)) {
					return
				}

				formData.set(
					keyName,
					this.$refs.addToCartTrigger.dataset[key],
				)
			}

			this.status = 'loading'
			fetch('/?wc-ajax=add_to_cart', {
				method: 'POST',
				body: formData,
			})
				.then(response => response.json())
				.then((data) => {
					if (data.error && data.product_url) {
						window.location = data.product_url
						return
					}

					replaceFragments(data.fragments)

					this.$nextTick(() => this.$dispatch('mini-cart:open'))

					this.status = null
				})
				.catch(() => {
					this.status = null
				})
		},
	}
}
